import { createFileRoute, redirect } from '@tanstack/react-router';

// A transform is a Library code item under the same id (automation §16).
export const Route = createFileRoute('/_shell/transforms/$transformId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/library/$itemId',
      params: { itemId: params.transformId },
      replace: true,
    });
  },
});
